export const dayPeriodsSelector = state => state?.dayPeriods?.get('results')?.toArray()
